import {useRef} from "react";
import Body from "../../../../../../../material/skeleton/Body";
import Box from "@mui/material/Box";
import {Button, TextField} from "@mui/material";
import Footer from "../../../../../../../material/skeleton/Footer";
import parameter from "../../../../../../../enum/parameter";
import {CheckCircle} from "@mui/icons-material";


export default function ({next}) {
    const difficultyInput = useRef();

    const nextStep = () => {
        next({
            difficulty: difficultyInput.current.value.length === 0
                ? "Néant"
                : difficultyInput.current.value
        });
    }

    return (
        <>
            <Body>
                <Box mt={5} px={2}>
                    <TextField
                        label={`Décrivez les difficultés que vous avez rencontrées`}
                        placeholder={"Attente du bénéficiaire, imprévu etc"}
                        fullWidth={true}
                        multiline={true}
                        minRows={10}
                        maxRows={20}
                        inputRef={difficultyInput}
                        data-test="input-difficulty"
                    />
                </Box>
            </Body>
            <Footer>
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    onClick={nextStep}
                    data-test="button-next-step"
                >
                    Étape suivante
                </Button>
            </Footer>
        </>
    );
}